// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1f-q";
export var animationRelative = "_1f-p";
export var backdropBlur = "_1f-0";
export var detailLabelCell = "_1f-12";
export var detailTable = "_1f-11";
export var detailValueCell = "_1f-13";
export var docIconBox = "_1f-1d";
export var docIconBoxMd = "_1f-1f";
export var docIconBoxSm = "_1f-1e";
export var docTypeRow = "_1f-16";
export var docTypeRowInner = "_1f-17";
export var dropdownMatchDatePicker = "_1f-3";
export var evidenceCardContent = "_1f-1c";
export var fileUploadSpin = "_1f-j";
export var gorgiasOpenButton = "_1f-15 _1f-d";
export var gorgiasTicketCard = "_1f-14";
export var heroModalFooterButton = "_1f-18";
export var hiddenContainer = "_1f-o";
export var iconPrimary = "_1f-1g";
export var iconQuaternary = "_1f-1i";
export var iconTertiary = "_1f-1h";
export var integrationCard = "_1f-1";
export var integrationLogoBox = "_1f-2";
export var mainColumnSticky = "_1f-1b";
export var maxWidthContainer = "_1f-19";
export var modalContentBody = "_1f-a";
export var modalHeaderImage = "_1f-5";
export var modalImageLabel = "_1f-7";
export var modalImageOverlay = "_1f-6";
export var modalImageSubtitle = "_1f-9";
export var modalImageTitle = "_1f-8";
export var modalImageWrapper = "_1f-4";
export var modalStickyFooter = "_1f-b";
export var removeButton = "_1f-e";
export var sidebarColumn = "_1f-1a";
export var spinner = "_1f-i";
export var timelineLine = "_1f-y";
export var timelineLineBlack = "_1f-10 _1f-y";
export var timelineLineGray = "_1f-z _1f-y";
export var timelineLineHeight = "_1f-x";
export var tlDotActivate = "_1f-u";
export var tlDotActivateAnim = "_1f-t";
export var tlDotHide = "_1f-s";
export var tlDotHideAnim = "_1f-r";
export var tlLineActivate = "_1f-w";
export var tlLineActivateAnim = "_1f-v";
export var uploadHint = "_1f-n";
export var uploadIconBox = "_1f-k";
export var uploadLabel = "_1f-m";
export var uploadText = "_1f-l";
export var uploadZone = "_1f-f";
export var uploadZoneCursorDefault = "_1f-h";
export var uploadZoneCursorPointer = "_1f-g";
export var uploadedFileRow = "_1f-c";
export var viewButton = "_1f-d";